/**
 * Default Sales / Attendance query window: the last 30 local calendar days
 * ending today (today inclusive). Dates are `YYYY-MM-DD` in the browser's
 * local calendar — no guessed tenant timezone.
 */
export function localIsoDate(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function lastThirtyLocalDays(now = new Date()): { from: string; to: string } {
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const from = new Date(to);
  from.setDate(from.getDate() - 29);
  return { from: localIsoDate(from), to: localIsoDate(to) };
}
